import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to}) => {
  const { pathname } = useLocation();

  return (
    <>
        {/* <Link to={to} className="flex group items-center space-x-2">
        <div className={`text-white w-[40%] transition-all group-hover:bg-primary/50 py-4 rounded-tr-full rounded-br-full flex justify-end pr-4 ${pathname === to ? "bg-primary/20" : ""}`}>
          <Icon className={`text-white text-2xl group-hover:text-primary ${pathname === to ? "text-primary" : ""}`}/>
        </div>
        <span className={`font-medium text-white group-hover:text-primary text-xs ${pathname === to ? "text-primary" : ""}`}>
          {title}
        </span>
      </Link> */}
        <Link to={to} className="group block">
          <div className={`group rounded-lg group-hover:bg-white/30 py-3 px-2 text-white w-[80%] mx-auto flex group items-center space-x-2 ${pathname === to ? "bg-secondary_dark" : ""}`}>
            <Icon className={`text-2xl ${pathname === to ? "text-white" : "text-white/90 group-hover:text-white"}`}/>
            <span className={`font-medium text-sm ${pathname === to ? "text-white" : "text-white/90 group-hover:text-white"}`}>
              {title}
            </span>
          </div>
        </Link>
    </>
  )
}

export default LinkContainer